import React, { Component } from "react";
import { Card, CardBody, CardHeader, Row, Col } from "reactstrap";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/fontawesome-free-solid";

import AnswerList from "components/questions/modify/AnswerList";
import QuestionListNormal from "components/questions/modify/QuestionListNormal";
import QuestionListEdit from "components/questions/modify/editQuestion";

class QuestionLists extends Component {
  render() {
    let index = 0;
    if (this.props.questions.length < 1) {
      return (
        <Card className="mt-4">
          <CardHeader>Oops!!! No questions</CardHeader>
          <CardBody>Add question to display here.</CardBody>
        </Card>
      );
    }
    const $questionsList = this.props.questions.map(question => {
      index++;
      return this.props.editId == question.id ? (
        <QuestionListEdit
          changeAnswerOrder = {this.props.changeAnswerOrder}
          editId={this.props.editId}
          question_original={question}
          question={this.props.question}
          answers_attributes={this.props.answers_attributes}
          confirmEdit={this.props.confirmEdit}
          cancelEdit={this.props.cancelEdit}
          handleChange={this.props.handleChange}
          confirmEdit={this.props.confirmEdit}
          addAnswer={this.props.addAnswer}
          deleteAnswer={this.props.deleteAnswer}
          answer={this.props.answer}
          index={index}
          key={question.id}
          handleKeyPress={this.props.handleKeyPress}
          editAnswerObject={this.props.editAnswerObject}
          editAnswerText={this.props.editAnswerText}
          editAnswer={this.props.editAnswer}
          cancelAnswerEdit={this.props.cancelAnswerEdit}
          confirmAnswerEdit={this.props.confirmAnswerEdit}
          questionError={this.props.questionError}
          answerError={this.props.answerError}
          editingQuestionId={this.props.editId}
          toggleForm={this.props.cancelEdit}
        />
      ) : (
        <QuestionListNormal
          editId={this.props.editId}
          editQuestion={this.props.editQuestion}
          deleteQuestion={this.props.deleteQuestion}
          question={question}
          index={index}
          key={question.id}
        />
      );
    });
    return <div>{$questionsList}</div>;
  }
}

export default QuestionLists;



// WEBPACK FOOTER //
// ./src/components/questions/modify/QuestionsLists.js